import RouteContainer from 'containers/RouteContainer';
import Loggedout from './components/Loggedout';

export const path = '/loggedout';

export default RouteContainer(path, Loggedout, { exact: true });
